import DeleteNewsAPI from "./deleteNewsAPI";

const DeleteNewsService = async (id: string): Promise<any> => {
  try {
    return await DeleteNewsAPI(id);
  } catch (error) {
    throw error;
  }
};

export default DeleteNewsService;